module.exports = __webpack_public_path__ + "fonts/TBCSailec-Medium.b2fcb5e2.eot";